import { Reducer } from 'redux';
import EmulationDTO from 'src/models/account/EmulationDTO';
import { KnownAction, LoginUserAction, UpdateUserAction, KnownUserStates, UpdateStateUserAction, UpdateErrorUserAction, ResetUserAction, UpdateEmulateUserAction } from './UserActions';

/**
 * This is both the UserState and the default for the given state
 */
export class UserState {
    // Required
    public firstName: string;
    public lastName: string;
    public email: string;
    public roleID: number;
    public userId: number;

    // Lingual!
    public cultureId: number;
    public cultureCode: string;

    // Optional? Or maybe just not on everyone
    public districtId?: number;
    public schoolId?: number;
    public stateId?: number;
    public gradeId?: number;
    public clientId?: number;

    public districtName: string | null;
    public schoolName: string | null;
    public stateName: string | null;
    public clientName: string | null;

    public emulationInfo: EmulationDTO | null;

    /**
     * DEPRECATED: Quick and easy check to see if user has logged in.
     *
     * **Set exclusively by the reducer, do not set yourself**
     */
    public isLoggedIn: boolean;
    public isEmulating: boolean;
    public isSsoEnabled: boolean;

    /**
     * The state of the login object.
     *
     * **Set by the login actions, do not set yourself**
     */
    public state: KnownUserStates;
    public errorMsg: string;

    constructor() {
        this.firstName = "unknown";
        this.lastName = "unknown";
        this.email = "";
        this.roleID = 1;
        this.gradeId = 0;
        this.cultureId = 1;
        this.cultureCode = "en-us";

        this.isEmulating = false;
        this.state = "none";

        this.emulationInfo = null;
    }
}

export const UserReducer: Reducer<UserState> = (state: UserState = new UserState(), action: KnownAction) => {
    switch (action.type) {
        case "LOGIN_USER":
            let loginAction: LoginUserAction = action;
            return {
                ...state,
                // Statically using the names below in case they change
                firstName: loginAction.data.firstName,
                lastName: loginAction.data.lastName,
                email: loginAction.data.email,
                roleID: loginAction.data.roleID,
                gradeId: loginAction.data.gradeId,
                cultureId: loginAction.data.cultureId,
                cultureCode: loginAction.data.cultureCode,
                districtId: loginAction.data.districtId,
                schoolId: loginAction.data.schoolId,
                stateId: loginAction.data.stateId,
                isEmulating: loginAction.data.isEmulating,
                isSsoEnabled: loginAction.data.isSsoEnabled,

                clientId: loginAction.data.clientId,
                clientName: loginAction.data.clientName,
                userId: loginAction.data.userId,
                stateName: loginAction.data.stateName,
                districtName: loginAction.data.districtName,
                schoolName: loginAction.data.schoolName,
                checkpointId: loginAction.data.checkpointId,
                planetId: loginAction.data.planetId,
                stepId: loginAction.data.stepId,
                // state: "no" // Do not update this here
            };
        case "UPDATE_USER":
            let updateAction: UpdateUserAction = action;
            return {
                ...state,
                // Statically using the names below in case they change
                firstName: updateAction.data.firstName,
                lastName: updateAction.data.lastName,
                email: updateAction.data.email,
                roleID: updateAction.data.roleID,
                gradeId: updateAction.data.gradeId,
                cultureId: updateAction.data.cultureId,
                cultureCode: updateAction.data.cultureCode,
                districtId: updateAction.data.districtId,
                schoolId: updateAction.data.schoolId,
                stateId: updateAction.data.stateId,
                isEmulating: updateAction.data.isEmulating,
                isSsoEnabled: updateAction.data.isSsoEnabled,

                clientId: updateAction.data.clientId,
                clientName: updateAction.data.clientName,
                userId: updateAction.data.userId,
                stateName: updateAction.data.stateName,
                districtName: updateAction.data.districtName,
                schoolName: updateAction.data.schoolName,
                checkpointId: updateAction.data.checkpointId,
                planetId: updateAction.data.planetId,
                stepId: updateAction.data.stepId,
                // state: "no" // Do not update this here
            };
        case "UPDATE_STATE_USER":
            let updateStateAction: UpdateStateUserAction = action;
            return {
                ...state,
                state: updateStateAction.data
            };
        case "UPDATE_ERROR_USER":
            let updateErrorAction: UpdateErrorUserAction = action;
            return {
                ...state,
                errorMsg: updateErrorAction.data
            };
        case "RESET_USER":
            let resetUserAction: ResetUserAction = action;
            return new UserState();
        case "UPDATE_EMULATE_INFO_USER":
            let updateEmulateUserAction: UpdateEmulateUserAction = action;
            return {
                ...state,
                emulationInfo: updateEmulateUserAction.data
            };
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            // JB - Clarification: The following line is fucking magic
            const exhaustiveCheck: never = action;
    }

    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state;
};



// WEBPACK FOOTER //
// ./src/redux/UserReducer.ts